import { CARD, INVOICE } from 'consts';
import { EPaymentMethod } from 'enums';

export const getPaymentTypeString = (pmType: EPaymentMethod) => {
  if (pmType === EPaymentMethod.INVOICE) {
    return INVOICE;
  }

  if (pmType === EPaymentMethod.CARD) {
    return CARD;
  }

  return '';
};
